import AuthPageContainer from 'components/common/AuthPageContainer';
import React from 'react';

import { SignInFormContent } from './components';

const SignIn: React.FC = () => (
  <AuthPageContainer>
    {/* <AuthFormHeader /> */}
    <SignInFormContent />
  </AuthPageContainer>
);

export default React.memo(SignIn);
